export default __webpack_public_path__ + "57f5c1837853986ea1dbadbb8f4f6074.ttf";